
<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./avatar.png" width="80" height="80">
    </div>
    <div class="updated">2 IIX 2006</div>
  </div>
</template>

<script>
export default {
  name: "Avatar"
};
</script>

<style scoped>
.fertilizer {
  background-image: linear-gradient(#660099, #000033);
}
.box {
  margin-top: -40px;
}
.updated {
  color: #ccc;
}
</style>
